"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.defaultData = defaultData;
exports.deleted = deleted;
exports.detail = detail;
exports.edit = edit;
exports.list = list;
exports.previewGoods = previewGoods;
exports.setHome = setHome;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * api接口列表
 */
var api = {
  list: '/admin/page/list',
  defaultData: '/admin/page/defaultData',
  detail: '/admin/page/detail',
  previewGoods: '/admin/page/previewGoods',
  add: '/admin/page/add',
  edit: '/admin/page/edit',
  delete: '/admin/page/delete',
  setHome: '/admin/page/setHome'
};

/**
 * 列表记录
 */
function list(params) {
  return (0, _request.default)({
    url: api.list,
    method: 'get',
    params: params
  }).then(function (data) {
    return {
      data: data
    };
  });
}

/**
 * 详情记录
 */
function defaultData(params) {
  return (0, _request.default)({
    url: api.defaultData,
    method: 'get',
    params: params
  }).then(function (data) {
    return {
      data: data
    };
  });
}

/**
 * 页面详情
 */
function detail(params) {
  return (0, _request.default)({
    url: api.detail,
    method: 'get',
    params: params
  }).then(function (data) {
    return {
      data: data
    };
  });
}

/**
 * 装修预览商品（父分类含子分类）
 */
function previewGoods(params) {
  return (0, _request.default)({
    url: api.previewGoods,
    method: 'get',
    params: params
  }).then(function (data) {
    return {
      data: data
    };
  });
}

/**
 * 设置默认首页
 * @param {*} data
 */
function setHome(data) {
  return (0, _request.default)({
    url: api.setHome,
    method: 'post',
    data: data
  }).then(function (res) {
    return {
      data: res,
      message: '设置成功'
    };
  });
}

/**
 * 新增页面
 * @param {*} data
 */
function add(data) {
  return (0, _request.default)({
    url: api.add,
    method: 'post',
    data: data
  }).then(function (res) {
    return {
      data: res,
      message: '添加成功'
    };
  });
}

/**
 * 编辑页面
 * @param {*} data
 */
function edit(data) {
  return (0, _request.default)({
    url: api.edit,
    method: 'post',
    data: data
  }).then(function (res) {
    return {
      data: res,
      message: '更新成功'
    };
  });
}

/**
 * 删除记录
 * @param {*} data
 */
function deleted(data) {
  return (0, _request.default)({
    url: api.delete,
    method: 'post',
    data: data
  }).then(function (res) {
    return {
      data: res,
      message: '删除成功'
    };
  });
}